import getSecondsRemaining from '../getSecondsRemaining'
import { Status } from '../fetchWebcast'
import isWithinInterval from 'date-fns/isWithinInterval'

export type PageState = 'scheduled' | 'upcoming' | 'tminus5' | 'live' | 'processing' | 'ondemand'
export const PAGE_STATE_VALUES: PageState[] = [ 'scheduled', 'upcoming', 'tminus5', 'live', 'processing', 'ondemand' ]
export const defaultState: PageState = 'scheduled'
const COUNTDOWN_SECS = 86400

function getPageState (start: string, entry: string, status: Status): PageState {

  if (start === '' || entry === '') return defaultState

  if (status === 'recorded') return 'ondemand'
  if (status === 'processing') return 'processing'

  const startDate = new Date(start)
  const entryDate = new Date(entry)
  
  const secsRemaining = getSecondsRemaining(start)

  if (secsRemaining <= 0) return 'live'

  const isTMinus5 = isWithinInterval(Date.now(), {
    start: entryDate,
    end: startDate
  })

  if (isTMinus5) return 'tminus5'

  if (secsRemaining <= COUNTDOWN_SECS) return 'upcoming'
  
  return 'scheduled'

}

export default getPageState
